<template>
  <v-expansion-panel-content>
    <template v-slot:header>
      <h6 class="title">
        <v-icon
          class="mr-2"
        >
          account_balance
        </v-icon>
        Issuer
      </h6>
    </template>
    <v-card>
      <v-container
        fluid
        grid-list-sm
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            xs4
            sm2
          >
            <v-text-field
              v-model="issuer.city"
              label="City"
              :class="isFieldReadonly ? 'is-readonly' : ''"
              :color="colorTheme"
              :readonly="isFieldReadonly"
              @change="onValueChange"
            />
          </v-flex>
          <v-flex
            xs4
            sm2
          >
            <v-text-field
              v-model="issuer.spv_id"
              :class="isFieldReadonly ? 'is-readonly' : ''"
              label="SPV ID"
              :readonly="isFieldReadonly"
              :color="colorTheme"
              @change="onValueChange"
            />
          </v-flex>
          <v-flex
            xs4
            sm2
          >
            <v-text-field
              v-model="issuer.name"
              label="Name"
              :class="isFieldReadonly ? 'is-readonly' : ''"
              :readonly="isFieldReadonly"
              :color="colorTheme"
              @change="onValueChange"
            />
          </v-flex>
          <v-flex
            xs4
            sm2
          >
            <v-text-field
              v-model="issuer.street"
              label="Street"
              :class="isFieldReadonly ? 'is-readonly' : ''"
              :readonly="isFieldReadonly"
              :color="colorTheme"
              @change="onValueChange"
            />
          </v-flex>
          <v-flex
            xs4
            sm2
          >
            <v-text-field
              v-model="issuer.zip"
              label="ZIP"
              :class="isFieldReadonly ? 'is-readonly' : ''"
              :readonly="isFieldReadonly"
              :color="colorTheme"
              @change="onValueChange"
            />
          </v-flex>
          <v-flex
            xs4
            sm2
          >
            <v-text-field
              v-model="issuer.lei"
              label="LEI"
              :class="isFieldReadonly ? 'is-readonly' : ''"
              :readonly="isFieldReadonly"
              :color="colorTheme"
              @change="onValueChange"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-expansion-panel-content>
</template>

<script>

export default {
  name: 'IssuerExpansionPanel',
  props: {
    issuer: {
      type: Object,
      default: () => {},
    },
    stage: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    colorTheme: {
      type: String,
      default: 'blue',
    },
    onValueChange: {
      type: Function,
      required: true,
    },
  },
  computed: {
    isFieldReadonly() {
      return this.type === 'tranche';
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/financialProducts/IssuerExpansionPanel.vue